import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { Spinner } from 'react-bootstrap';
import { RemoteDataUI } from '../../../common/ui/RemoteDataUI';
import { useDebouncedEffect } from '../../../common/utils/useDemouncedEffect';
import { useFilterContext } from '../../catalog/infrastructure/FilterContext';
import { FilterSection } from '../../catalog/ui/FilterSection';
import { serializeFiltersToQuery } from '../../catalog/infrastructure/filterUrlMapper';
import { useTenantContext } from '../../../tenant/TenantContext';
import { Hero, PromoSection, readStateFromParams } from './PromocionesPage';
import {
    SearchWrapper,
    SearchContainer,
    SearchInput,
    SearchIconWrapper,
} from '../../catalog/ui/filter-panel/ProductSearchFilter.styles';

const NEW_CHARACTERISTICS = { isNew: true };

/**
 * Seccion "Nuevos": mismo patron que la de Ofertas (banda de color con buscador propio +
 * panel de filtros lateral) pero sin pestañas y con la banda en el color del tenant,
 * igual que su pildora del menu.
 */
export const NuevosPage = () => {
    const { filterOptionsRemoteData } = useFilterContext();
    const { primaryColor } = useTenantContext();
    const [searchParams, setSearchParams] = useSearchParams();
    // Estado inicial desde la URL, para que "volver" desde una ficha no reinicie nada.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initialState = useMemo(() => ({
        ...readStateFromParams(searchParams),
        page: parseInt(searchParams.get('p') || '0', 10) || 0,
    }), []);

    const [searchInput, setSearchInput] = useState(initialState.search);
    const [search, setSearch] = useState(initialState.search);
    const [page, setPage] = useState(initialState.page);
    // Filtros del panel, locales a esta pagina (no tocan el FilterContext global).
    const [panelFilter, setPanelFilter] = useState(initialState.panelFilter);
    const [viewMode, setViewMode] = useState('grid');

    useDebouncedEffect(() => {
        setSearch(searchInput.trim());
    }, [searchInput], 300);

    // Estado → URL (replace para no ensuciar el historial con cada tecla).
    useEffect(() => {
        const params = serializeFiltersToQuery({ search, ...panelFilter });
        if (page > 0) params.set('p', String(page));
        setSearchParams(params, { replace: true });
    }, [search, panelFilter, page, setSearchParams]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            setSearch(searchInput.trim());
        }
    };

    return (
        <div className="container">
            <Hero $bg={primaryColor}>
                <h1>Nuevos</h1>
                <p>Las últimas incorporaciones al catálogo.</p>

                <div className="d-flex justify-content-center">
                    <SearchWrapper>
                        <SearchContainer>
                            <SearchInput
                                placeholder="Busca dentro de los nuevos"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyDown={handleKeyDown}
                                type="text"
                            />
                            <SearchIconWrapper onClick={() => setSearch(searchInput.trim())}>
                                <SearchIcon />
                            </SearchIconWrapper>
                        </SearchContainer>
                    </SearchWrapper>
                </div>
            </Hero>

            <div className="row">
                {/* En movil el panel de filtros se oculta entero (decision usuario 11-ago). */}
                <aside className="col-12 col-lg-3 mb-4 d-none d-lg-block">
                    <RemoteDataUI remoteData={filterOptionsRemoteData}>
                        <RemoteDataUI.Pending>
                            <div className="text-center"><Spinner /></div>
                        </RemoteDataUI.Pending>

                        <RemoteDataUI.Failure>
                            <div className="alert alert-danger">
                                Imposible cargar Filtros. Intentelo más tarde.
                            </div>
                        </RemoteDataUI.Failure>

                        <RemoteDataUI.Success>
                            {filterOptions =>
                                <FilterSection
                                    filterOptions={filterOptions}
                                    filter={panelFilter}
                                    viewMode={viewMode}
                                    onFilterChange={setPanelFilter}
                                    onViewModeChange={setViewMode}
                                />
                            }
                        </RemoteDataUI.Success>
                    </RemoteDataUI>
                </aside>

                <main className="col-12 col-lg-9 p-0">
                    <PromoSection
                        title="ARTÍCULOS NUEVOS"
                        characteristics={NEW_CHARACTERISTICS}
                        search={search}
                        panelFilter={panelFilter}
                        viewMode={viewMode}
                        hideWhenEmpty={false}
                        page={page}
                        onPageChange={setPage}
                    />
                </main>
            </div>
        </div>
    );
};
